<template>
  <div class="dashboard-top-right bg-light p-2">
    <div class="text-bold">Belanja TKDN</div>
    <div style="font-size:10px; font-weight: bold; margin-bottom:10px">
      Dalam perbandingan dengan nilai Pengadaan
    </div>
    <line-chart :chartData="chartData" :options="chartOptions" :styles="{ height: '70%' }"
      v-if="belanjaTkdn && belanjaTkdn.length > 0" />
  </div>
</template>
<script>
import numeral from 'numeral'
export default {
  components: {
    lineChart: () => import('@/components/chart/dashboard/line-chart.vue'),
  },
  data() {
    return {
      chartData: {
        labels: ['2020', '2021', '2022'],
        datasets: [
          {
            data: [0],
            fill: false,
            borderColor: 'red',
          },
        ],
      },
      chartOptions: {
        showDatapoints: true,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: 20,
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return `${label} %`
            },
          },
        },
        elements: {
          line: {
            tension: 0,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                display: false,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            anchor: 'start',
            align: 'top',
            formatter: function (value, context) {
              let label = ''

              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(value).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return `${label} %`
            },
            font: {
              weight: 'bold',
              size: 10,
            },
          },
        },
      },
    }
  },
  computed: {
    belanjaTkdn() {
      let data = this.$store.state.tkdnStore.belanjaDomestik
      this.convertData(data)

      return data
    },
  },
  methods: {
    convertData(data) {
      if (data && data.length > 0) {
        let labels = []
        let belanjaTkdn = []

        data.forEach(item => {
          labels.push(item.YEAR)
          belanjaTkdn.push(
            (Number(item.TOTAL_TKDN) / Number(item.VALUE_LC)) * 100
          )
        })

        this.chartData.labels = labels
        this.chartData.datasets[0] = {
          data: belanjaTkdn,
          fill: false,
          borderColor: 'red',
        }
      }
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 33%;
  height: 100%;
  position: relative;
}

.chart-text-center {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 8px;
}
</style>
